export default __webpack_public_path__ + "static/media/react-crud.fdc8750f.png";